import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CloudFunctionsService } from 'src/app/services/cloud-functions.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { version, commitHash } from 'src/environments/buildInfo';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'settings-for-advanced',
  standalone: true,
  imports: [MatButtonModule, CommonModule],
  templateUrl: './settings-for-advanced.component.html',
  styleUrl: './settings-for-advanced.component.scss',
})
export class SettingsForAdvancedComponent {
  isClearingCache = false;
  version = version;
  commitHash = commitHash;
  isDownloadingEntries = false;

  constructor(
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    private cloudFunctionsService: CloudFunctionsService
  ) {}

  async clearCache() {
    this.isClearingCache = true;
    this.unregisterServiceWorkers();
    this.clearServiceWorkerCache();
    this.restartApp();
  }

  private unregisterServiceWorkers() {
    navigator.serviceWorker.getRegistration().then(function (registration) {
      if (registration) {
        registration.unregister().then(function (success) {
          // if success = true, unregister was successful
        });
      }
    });
  }

  private clearServiceWorkerCache() {
    if ('caches' in window) {
      caches.keys().then(function (keyList) {
        return Promise.all(
          keyList.map(function (key) {
            return caches.delete(key);
          })
        );
      });
    }
  }

  private restartApp() {
    window.location.reload();
  }

  async downloadEntriesAsCsv() {
    if (this.authService.isDemo) {
      this._snackBar.open('Not available in demo. Please log in.');
    } else {
      this.isDownloadingEntries = true;
      try {
        await this.cloudFunctionsService.downloadUserEntriesAsCsv();
      } catch (e) {
        this._snackBar.open(JSON.stringify(e));
      } finally {
        this.isDownloadingEntries = false;
      }
    }
  }
}
